var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAverage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.977,
    cy: 17.3208,
    r: 16.1408,
    stroke: "#EED500",
    strokeWidth: 1.89892
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6809 24.5581C25.2708 24.5581 25.749 24.0798 25.749 23.49C25.749 22.9 25.2708 22.4218 24.6808 22.4218H11.2713C10.6813 22.4218 10.2031 22.9001 10.2031 23.49C10.2031 24.0798 10.6813 24.5581 11.2713 24.5581H24.6809Z",
    fill: "#EED500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6402 13.9977C13.82 13.9977 14.7765 13.0412 14.7765 11.8614C14.7765 10.6815 13.82 9.7251 12.6402 9.7251C11.4604 9.7251 10.5039 10.6815 10.5039 11.8614C10.5039 13.0412 11.4604 13.9977 12.6402 13.9977Z",
    fill: "#EED500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.316 13.9977C24.4958 13.9977 25.4523 13.0412 25.4523 11.8614C25.4523 10.6815 24.4958 9.7251 23.316 9.7251C22.1361 9.7251 21.1797 10.6815 21.1797 11.8614C21.1797 13.0412 22.1361 13.9977 23.316 13.9977Z",
    fill: "#EED500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverage);
export default __webpack_public_path__ + "static/media/average.610a50b2b875306a5b6133f1b3be2693.svg";
export { ForwardRef as ReactComponent };